import { Tooltip } from 'antd'
import CustomTag from 'components/CustomTag'
import {
  RowNumberData,
  RowNumberDataReport,
  RowNumberDataReportAlignCenter,
  SkillRow,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import {
  RefinedData,
  arrayIntoString,
} from 'modules/Report/CommonFunction/Function.js'
import { InterviewScheduleTitle } from 'modules/Report/ExcelHeaderData.js'
import PageContent from 'modules/Report/Partials/CommonTable/PageContent.js'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { serialNo } from '../../CommonFunction/Function'
import { setInterviewSchedule } from '../../action'
const HiringStatus = ({
  cityData,
  cityDetails,
  interviewDetails,
  rolesPublishedData,
  excelDataForReport,
  roleDetails,
  roleData,
  corporateData,
}) => {
  const dispatch = useDispatch()
  const [dateError, setDateError] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [excelLoading, setExcelLoading] = useState(false)
  const [loadingRole, setLoadingRole] = useState(false)
  const [loadingRoleFilter, setLoadingRoleFilter] = useState(false)
  const [searchRoleValue, setSearchRoleValue] = useState('')
  const [roleValue, setRoleValue] = useState([])
  const [debounced, setDebounced] = useState(() => roleNameValue)
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [appendDateFilter, setAppendDateFilter] = useState([])
  const [clearDate, setClearDate] = useState(false)
  const [roleNameValue, setRoleNameValue] = useState()
  const [clear, setClear] = useState(false)
  const [error, setError] = useState('')
  const [rank, setRank] = useState('')
  const [rankSign, setRankSign] = useState('')
  const [filterData, setFilterData] = useState({
    rank: '',
    rankSign: '',
  })
  const [tooltip, setTooltip] = useState(false)
  const [sortBy, setSortBy] = useState({})
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])
  const [previousPage, setPreviousPage] = useState('')
  const onPageChange = pageNum => {
    setPreviousPage(currentPage)
    setCurrentPage(pageNum)
  }
  function toCamelCase(str) {
    const words = str.split(' ')
    const camelCaseWords = words.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    return camelCaseWords.join(' ')
  }
  function hasData(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }
  useEffect(() => {
    dispatch(setInterviewSchedule())
  }, [])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(roleNameValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [roleNameValue])

  const clearFilter = () => {
    setRoleValue([])
    setAppendDateFilter([])
    setCreatedAtStart('')
    setCreatedAtEnd('')
    setClearDate(true)
    setRank('')
    setRankSign('')
    setSearchRoleValue('')
    setClear(true)
    setRoleNameValue('')
    dispatch(setInterviewSchedule())
    setFilterData({
      rank: '',
      rankSign: '',
    })
  }
  const applyFilter = () => {
    let filterData = {
      role: arrayIntoString(roleValue),
      createdAtStart: createdAtStart,
      createdAtEnd: createdAtEnd,
      rank: rank,
      rankSign: rankSign,
    }
    if (createdAtStart) {
      if (!createdAtEnd) {
        WarningMessage(
          <>
            Kindly select <q>To Date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd) {
      if (!createdAtStart) {
        WarningMessage(
          <>
            Kindly select <q>From date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd && createdAtStart && error == '') {
      setFilterData(filterData)
    }
    if (!createdAtEnd && !createdAtStart && error == '' && !dateError) {
      setFilterData(filterData)
    }
    if (error || dateError) {
      setTooltip(true)
      WarningMessage(<>Kindly check the error in filter</>)
    }
  }
  useEffect(() => {
    if (error !== '' || dateError) {
      setTooltip(true)
    }
  }, [error, dateError])
  const tableData = excelDataForReport?.result?.map((item, index) => [
    { value: index + 1 },
    {
      value: item.serial_no ? Number(item.serial_no) : '-',
    },
    {
      value: item.mode
        ? item.mode
            ?.split('_')
            ?.map(
              word =>
                word?.charAt(0)?.toUpperCase() + word.slice(1)?.toLowerCase()
            )
            ?.join(' ')
        : '-',
    },
    { value: item.interviewer_name ? item.interviewer_name : '-' },
    {
      value: item.first_name
        ? item.first_name +
          (item.last_name ? ' ' + String(item.last_name).trim() : '')
        : '-',
    },
    { value: item.work_experience ? item.work_experience : '-' },
    {
      value: item.short_form ? item.short_form : '-',
    },
    { value: item.department ? toCamelCase(item.department) : '-' },
    { value: item.skills ? RefinedData(JSON?.parse(item.skills)) : '' },
    {
      value: item.rating ? Number(Number(item.rating)?.toFixed(2)) : '-',
    },
  ])
  const excelData = [{ columns: InterviewScheduleTitle, data: tableData }]
  const onSorting = (pagination, row, sorter) => {
    let order = ''
    let sort = sorter.field
    if (sorter.order === 'descend') {
      order = 'desc'
    } else if (sorter.order === 'ascend') {
      order = 'asc'
    } else {
      sort = ''
    }
    let sortBy = {
      orderBy: order,
      sortName: sort,
    }
    setSortBy(sortBy)
  }
  useEffect(() => {
    if (hasData(filterData)) {
      interviewDetails(10, 1, setLoadingRole, roleNameValue, filterData, sortBy)
      setCurrentPage(1)
    }
  }, [debounced, filterData, sortBy])
  useEffect(() => {
    if (hasData(filterData)) {
      if (currentPage) {
        if (hasData(filterData))
          interviewDetails(
            10,
            currentPage,
            setLoadingRole,
            roleNameValue,
            filterData,
            sortBy
          )
      }
    }
  }, [currentPage])
  useEffect(() => {
    let filterData = {
      role: arrayIntoString(roleValue),
      createAtStart: createdAtStart,
      createAtEnd: createdAtEnd,
      rank: rank,
      rankSign: rankSign,
    }

    setTooltip(hasData(filterData))
  }, [
    roleValue,
    createdAtStart,
    createdAtEnd,
    rank,
    rankSign,
    clear,
    clearDate,
  ])
  const columns = [
    {
      title: 'SR. NO',
      dataIndex: 'id',
      width: '5%',
      align: 'center',

      render: (text, record, index) => (
        <RowNumberDataReportAlignCenter>
          {serialNo(index, previousPage, currentPage, loadingRole)}
        </RowNumberDataReportAlignCenter>
      ),
    },

    {
      title: 'Drive Number',
      width: '10%',
      dataIndex: 'c.serial_no',
      sorter: true,
      align: 'center',
      render: (_, { serial_no }) => (
        <RowNumberDataReportAlignCenter>
          {serial_no}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Drive type',
      dataIndex: 'c.mode',
      sorter: true,
      render: (_, { mode }) => (
        <RowNumberDataReport>
          {mode
            ?.split('_')
            ?.map(
              word =>
                word?.charAt(0)?.toUpperCase() + word.slice(1)?.toLowerCase()
            )
            ?.join(' ')}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'interviewer name',
      sorter: false,
      dataIndex: 'b.interviewer_name',
      render: (_, { interviewer_name }) => (
        <RowNumberDataReport>{interviewer_name || '-'}</RowNumberDataReport>
      ),
    },
    {
      title: 'Candidate name',
      dataIndex: 'd.first_name',
      sorter: true,
      render: (_, { first_name, last_name }) => (
        <RowNumberDataReport>
          {first_name + (last_name ? ' ' + String(last_name).trim() : '')}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'Exp.level',
      dataIndex: 'd.work_experience',
      sorter: false,
      align: 'center',
      render: (_, { work_experience }) => (
        <RowNumberDataReportAlignCenter>
          {work_experience || '-'}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'degree',
      dataIndex: 'e.degree',
      key: 'e.degree',
      sorter: true,
      render: (_, { short_form, degree }) => (
        <RowNumberDataReport>
          {short_form
            ? short_form + ' - ' + toCamelCase(degree)
            : toCamelCase(degree)}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'course',
      dataIndex: 'e.department',
      key: 'e.department',
      sorter: true,
      render: (_, { department }) => (
        <RowNumberDataReport>
          {department
            ?.split('_')
            ?.map(
              word =>
                word?.charAt(0)?.toUpperCase() + word.slice(1)?.toLowerCase()
            )
            ?.join(' ')}
        </RowNumberDataReport>
      ),
    },
    {
      title: 'Primary Skills',
      dataIndex: 'e.skills',
      key: 'e.skills',
      sorter: false,
      render: (_, { skills }) => (
        <RowNumberDataReport>
          <Tooltip title={skills ? RefinedData(JSON?.parse(skills)) : ''}>
            {skills ? (
              <SkillRow>
                {JSON?.parse(skills)?.length > 1 ? (
                  <>
                    <CustomTag
                      message={JSON?.parse(skills)?.[0]?.name}
                      bordered={true}
                      background="#F2F3F5"
                      colorType="#808697"
                      border="#F2F3F5"
                    />
                    <CustomTag
                      message={`+${JSON?.parse(skills || '[]')?.length - 1}`}
                      bordered={true}
                      background="#F2F3F5"
                      colorType="#808697"
                      border="#F2F3F5"
                    />
                  </>
                ) : JSON?.parse(skills)?.length === 1 ? (
                  <CustomTag
                    message={JSON?.parse(skills || '[]')?.[0]?.name}
                    bordered={true}
                    background="#F2F3F5"
                    colorType="#808697"
                    border="#F2F3F5"
                  />
                ) : (
                  <RowNumberData>-</RowNumberData>
                )}
              </SkillRow>
            ) : (
              <RowNumberData>-</RowNumberData>
            )}
          </Tooltip>
        </RowNumberDataReport>
      ),
    },
    {
      title: 'student raNK',
      dataIndex: 'f.rating',
      key: 'f.rating',
      sorter: true,
      align: 'center',
      render: (_, { rating }) => (
        <RowNumberDataReportAlignCenter>
          {Number(rating)?.toFixed(1)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Profile link',
      dataIndex: 'status',
      key: 'status',
      sorter: false,
      render: (_, { offer_expire_date }) => (
        <RowNumberDataReport>{'-'}</RowNumberDataReport>
      ),
    },
  ].filter(item => !item.hidden)
  const clickedExcel = data => {
    let excel = true
    interviewDetails(
      5000,
      1,
      setExcelLoading,
      roleNameValue,
      filterData,
      sortBy,
      excel
    )
    setIsExcel(data)
  }

  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingRole) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingRole])
  const handleHover = () => {
    if (rolesPublishedData?.count > 5000) {
      WarningMessage(
        'Note : The Candidate Interview Schedule count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  const dataSign = data => {
    setRankSign(data.rankSign)
    setRank(data.rank)
  }
  const FilterData = [
    {
      id: 3,
      headerName: 'Role',
      searchValue: searchRoleValue,
      setSearchValue: setSearchRoleValue,
      setValue: setRoleValue,
      value: roleValue,
      data: roleData,
      apicall: roleDetails,
      setLoading: setLoadingRoleFilter,
      loading: loadingRoleFilter,
      valueParam: 'id',
      labelParam: 'tittle',
      divider: false,
      flag: 'IS',
    },
    {
      id: 6,
      headerName: 'Rank',
      setRank: setRank,
      setRankSign: setRankSign,
      divider: false,
    },
    {
      id: 1,
      headerName: 'Date Range',
      setCreatedAtStart: setCreatedAtStart,
      setCreatedAtEnd: setCreatedAtEnd,
      clearDate: setClearDate,
      clear: clearDate,
    },
  ]

  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'REPORTS',
    'Interview Schedule'
  )
  return (
    <>
      {' '}
      <PageContent
        corporateName={corporateData?.name}
        columnWidths={[15, 25, 35, 43, 35, 15, 24, 40, 30, 23, 23, 20]} // Array of column widths
        columnFontSize={10} // Font size for the column data
        HAlign={[
          'center',
          'center',
          'center',
          'left',
          'left',
          'center',
          'center',
          'left',
          'left',
          'right',
          'center',
          'center',
        ]}
        setDateError={setDateError}
        filterData={FilterData}
        cityData={cityData}
        cityDetails={cityDetails}
        pageHeader="Candidate Interview Schedule"
        hasProp={hasData(filterData)}
        column={columns}
        tableData={rolesPublishedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onPageChange={onPageChange}
        setSearchRoleValue={setRoleNameValue}
        searchRoleValue={roleNameValue}
        applyFilter={applyFilter}
        clearFilter={clearFilter}
        onChange={onSorting}
        width={'100'}
        loadingRole={loadingRole}
        tooltip={tooltip}
        handleHover={handleHover}
        clickedExcel={clickedExcel}
        excel={excel}
        isExcel={isExcel}
        setIsExcel={setIsExcel}
        excelLoading={excelLoading}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        setAppendDateFilter={setAppendDateFilter}
        appendDateFilter={appendDateFilter}
        clearDate={clearDate}
        setClearDate={setClearDate}
        clear={clear}
        setClear={setClear}
        error={error}
        setError={setError}
        dataSign={dataSign}
        subEvents={subEvents}
      />
    </>
  )
}
export default HiringStatus
